export default "__VITE_ASSET__df7fb410__"